//@ts-nocheck directive
import React, { useState, useEffect } from "react";
import { UpdateUserProfileType } from "../Types/userProfile";
//import MemberFred from "../../Images/Fred3.jpg";
import styles from "./Connection.module.css";

import "../lib/RequireUser/index.css";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, set } from "firebase/database";
import { auth, app } from "../lib/firebase";
import {
  doc,
  getFirestore,
  updateDoc,
  arrayRemove,
  query,
  collection,
  where,
  onSnapshot,
} from "firebase/firestore";
import CreatePhotoURL from "./CreatePhotoURL";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";
import WelcomePage from "../WelcomePage/WelcomePage";
import { useAuthState } from "react-firebase-hooks/auth";
import { updateProfile } from "firebase/auth";
import UpdateUserProfileName from "../UserProfile/UpdateUserProfileName";
import photoURL from "../../Images/photoURL.png";
import Upload from "../Cloud/Upload";

interface IProps {
  userProfile: UpdateUserProfileType;
}
const tempUser = localStorage.getItem("userUID");
const db = getFirestore(app);
const storageName = "https://storage.googleapis.com/";

const bucketName = "footprints-b291f.appspot.com/";

let requestFromEmail = "";
let requestToEmail = "";
//gs://footprints-b291f.appspot.com/Fred3.jpg
//const fullURL = storageName + bucketName + photoName;

function MyConnectionsPost({ userProfile }: IProps) {
  const [userAbout, setUserAbout] = useState(userProfile.userAbout);
  const [userFirstName, setUserFirstName] = useState(userProfile.userFirstName);
  const [userLastName, setUserLastName] = useState(userProfile.userLastName);

  const [userProfileLink1, setUserProfileLink1] = useState(
    userProfile.userProfileLink1
  );
  const [userProfileLink2, setUserProfileLink2] = useState(
    userProfile.userProfileLink2
  );
  const [userProfileLink3, setUserProfileLink3] = useState(
    userProfile.userProfileLink3
  );
  const [userProfileLink4, setUserProfileLink4] = useState(
    userProfile.userProfileLink4
  );

  const [userPhotoName, setUserPhotoName] = useState(
    storageName + bucketName + userProfile.userPhotoName
  );
  const [userProfileName, setUserProfileName] = useState(
    userProfile.userProfileName
  );
  const [userCountry, setUserCountry] = useState(userProfile.userCountry);
  const [userEmail, setUserEmail] = useState(userProfile.userEmail);

  const [selectedFile, setSelectedFile] = useState<File | null>(null); // Add state for the selected file

  const [thisUserProfile, setThisUserProfile] = useState<NewUserProfileType[]>(
    []
  );

  const [userConnectionsRefArray, setUserConnectionsRefArray] = useState<
    NewUserProfileType[]
  >([]);

  function getSelect(e: ChangeEvent<HTMLSelectElement>) {
    console.log("selectedValue = ", e);
    //const temp = e.currentTarget.selectedIndex;
    let temp = e;

    setUserCountry(temp);
    console.log("temp value for country = ", temp);
  }
  const qUser = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  //load only this user's profile
  useEffect(
    () =>
      onSnapshot(qUser, (snapshot) => {
        setThisUserProfile(
          snapshot.docs.map((doc) => {
            if (doc.id) {
              console.log(
                " toMe got a doc id from onSnapshot for thisUserProfile "
              );
              userConnectionsRefArray.push(doc.id);
              console.log(
                " userConnectionsRefArray [0] ",
                userConnectionsRefArray[0]
              );
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  if (thisUserProfile.length != 0) {
    requestToEmail = thisUserProfile[0].userEmail;
    console.log("requestToEmail = ", requestToEmail);
  }
  //To do
  //Get thisUsers profile and refArray
  //Add disconnectButtonFunction

  //import { doc, updateDoc, arrayRemove } from "firebase/firestore";

  //const docRef = doc(db, "your_collection", "your_document_id");

  // Remove elements from the 'items' array
  //await updateDoc(docRef, {
  //    items: arrayRemove("item_to_remove_1", "item_to_remove_2")
  //});
  async function disconnectButtonFunction(userEmail) {
    console.log("in accept button function");
    //Two things to do
    //First: add the accepted user's email to the usrConnections arry in thisUser's profile
    // "your_collection = "userProfiles"
    // "your_document_id" = userConnectionsRefArray[0]
    //  new_item_1 = userEmail
    // const docRef = doc(db, "your_collection", "your_document_id");
    // Add new elements to the 'items' array
    // await updateDoc(docRef, {
    // items: arrayUnion("new_item_1", "new_item_2")
    //});
    const connectionRefArrayID = userConnectionsRefArray[0];
    const docRef = doc(db, "userProfiles", connectionRefArrayID);
    await updateDoc(docRef, {
      userConnections: arrayRemove(userEmail),
    });
  }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <h1 className={styles.header}>User Profile</h1>
          <button
            style={{ marginLeft: -150 }}
            className={styles.userButtons}
            onClick={() => disconnectButtonFunction(userEmail)}
          >
            Disconnect
          </button>
          <button
            style={{ marginLeft: 100 }}
            className={styles.userButtons}
            onClick={() => history.back()}
          >
            Return
          </button>
        </div>
        <div>
          <label className={styles.userLabel}>First Name</label>
          <input
            type="text"
            readOnly
            style={{ paddingLeft: 3, marginLeft: 10 }}
            defaultValue={userFirstName}
          />
          <div>
            <label className={styles.userLabel}>Last Name</label>
            <input
              type="text"
              readOnly
              style={{ paddingLeft: 3, marginLeft: 12 }}
              defaultValue={userLastName}
            />
          </div>
          <div>
            <label className={styles.userLabel}>Profile Name</label>
            <input
              type="text"
              readOnly
              style={{ paddingLeft: 3, marginLeft: -3 }}
              defaultValue={userProfileName}
            />
          </div>
        </div>
        <div>
          <label className={styles.userLabel}>Country</label>
          <input
            type="text"
            readOnly
            style={{ paddingLeft: 3, marginLeft: 30 }}
            defaultValue={userCountry}
          />
        </div>
        <div>
          <label className={styles.userLabel}>Email</label>
          <input
            type="text"
            readOnly
            style={{ paddingLeft: 3, marginLeft: 43 }}
            defaultValue={userEmail}
          />
        </div>
        <div>
          <label className={styles.userLabel}>Photo</label>
          <img
            className={styles.userPhoto}
            src={userPhotoName}
            alt=""
            style={{
              paddingTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              height: 200,
              objectFit: "scale-down",
              marginLeft: 28,
            }}
          />
        </div>
        <br />
        <div className={styles.aimLabel}>
          <label>About...(useful for journals' "About the Author")</label>
          <textarea
            className={styles.messageText}
            style={{
              paddingLeft: 3,
              marginLeft: 30,
              width: 400,
              height: 170,
            }}
            defaultValue={userAbout}
          />
        </div>

        <div className={styles.userLabel}>
          <label>Profile Links</label>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 273,
            }}
            type="text"
            defaultValue={userProfileLink1}
          />
          <a
            href={userProfile.userProfileLink1}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 360,
            }}
            type="text"
            defaultValue={userProfileLink2}
          />
          <a
            href={userProfile.userProfileLink2}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 360,
            }}
            type="text"
            defaultValue={userProfileLink3}
          />
          <a
            href={userProfileLink3}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 360,
            }}
            type="text"
            defaultValue={userProfileLink4}
          />
          <a
            href={userProfileLink4}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button className={styles.openButtons}>Open</button>
          </a>
        </div>
      </div>
    </>
  );
}

export default MyConnectionsPost;
